import React from "react";
import moment from 'moment';
import {
  Button, 
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import {AgentService } from "../services";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class CreateAgentInvoiceForm extends React.Component {
  constructor(props) {
    super(props); 
    //this.roleService = new RoleService();
   // this.mobileOperatorService = new MobileOperatorService();
    this.agentService = new AgentService();
  }

  state = {
    agent: {  //agent
     
      businessName: "",//name
      subscriptionBalance: "", //insert
      subscriptionExpiry:"",//show
      proprietorName:"",//show
      cityName:"",//show
      adjustmentAmount:"",//insert
      itemName:"",//insert
      amountDue:"",//insert
      discount:"",//insert
      dueDate:"",//insert
      agentId: ""//insert
      //remarks:""
    },
  //  subscriptionTypes: [],//operators
    //status: [],
    errors: {}
  };

  schema = Joi.object().keys({
    agentId: Joi.number(),
    cityName: Joi.any(),
    businessName:Joi.any(),
    proprietorName:Joi.any(),
    subscriptionBalance:Joi.number(),
    adjustmentAmount:Joi.number()
    .required()
    .error(errors => {
      return {
        message: "Select adjust amount"
      };
    }),
    itemName:Joi.string()
    .required()
    .error(errors => {
      return {
        message: "Select item name"
      };
    }),
    amountDue:Joi.number()
    .required()
    .error(errors => {
      return {
        message: "Select amount due"
      };
    }),
    discount:Joi.number()
    .required()
    .error(errors => {
      return {
        message: "Select discount"
      };
    }),
    dueDate: Joi.date()
    .required()
    .error(errors => {
      return {
        message: "Select Due Date"
      };
    }),
    subscriptionExpiry:Joi.any(),
  });

  componentDidMount() {
    this.getUser();
  }

  async getUser() {
    try {
      let {agentId} = this.props;
      console.log("my agent id",agentId);
      // if (agentId === "") {
      //   return;
      // }
      let { data } = await httpClient.get(`/agent/${agentId}`);
      //console.log("agent data",data);
      let agent = data["response"][0][0];
     // console.log("agent 111 data",agent);
      let info = {
        agentId: agentId,
        businessName: agent["business_name"],
        proprietorName: agent["proprietor_name"],
        cityName:agent["city_name"],
        subscriptionBalance:agent["subscription_balance"],
        subscriptionExpiry:agent["subscription_expiry"],
        dueDate :agent["due_date"],
      };
      //console.log("Info data",info);
      
      this.setState({agent: info });
    } catch (error) {
      let agent = {
      businessName: "",
      subscriptionBalance: "",
      subscriptionExpiry:"",
      proprietorName:"",
      cityName:"", 
      agentId: "",
      dueDate:""
      };
      this.setState({agent:agent});
    }    
  }

  reset = () => {
    let agent = {
      businessName: "",//name
      subscriptionBalance: "",
      subscriptionExpiry:"",
      proprietorName:"",
      cityName:"",
      adjustmentAmount:"",//insert
      itemName:"",//insert
      amountDue:"",//insert
      discount:"",//insert
      dueDate:""//insert
    };

    let errors = {};
    this.setState({ agent, errors });
  };

 
  validation() {
   // console.log("ERRORS DATA",this.state.agent);
    let { error } = Joi.validate(this.state.agent, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // handle change
  handleChange = event => {
    let value = event.target.value;
    let agent = { ...this.state.agent };
    agent[event.target.name] = value;
    this.setState({ agent });
    //console.log("HANDLE CHANGE",agent);
  };
  handledDueDate = date => {
    let agent = { ...this.state.agent };
    
    agent.dueDate = date;
    this.setState({
      agent
    });
    console.log("MY DUE DATE",agent);
  };
  // on submit
  handleSubmit = async (event) => {
    event.preventDefault();
    // validation
    let errors = this.validation();

    if (errors) {
      console.log(errors);

      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let agent = this.state.agent;
   // console.log("my invoice data",agent);
    try {

  //console.log("my invoice data",agent);
  const agentInvoiceData={
   agentId : agent.agentId,
   subscriptionBalance : agent.subscriptionBalance,
   adjustmentAmount : agent.adjustmentAmount,
   itemName : agent.itemName,
   amountDue : agent.amountDue,
   discount : agent.discount,
   dueDate :agent.dueDate
 }
 console.log("this is fro token",this.props.successfullyLogin)
 console.log("Update request Send",agentInvoiceData);
 //console.log("API DATA",agentInvoiceData);
      var { status, data } =await httpClient.post("/agent/create_invoice",agentInvoiceData);
      console.log("status",status);
      if (status === 200) {
        // show verification modal
        toast.success("دی گئی معلومات محفوظ کر دی گئی ہیں", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.reset();
        this.props.toggle();
        //this.props.getUser();
        //this.props.fetchUses();
        //window.location.reload();
      }
      //window.location.reload();
    } catch (error) {
      // error occur

      console.log("ERORS",error);
      
      toast.error("Oops something went wrong!!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
     // window.location.reload();
     }
  };
  
  render() {
    // let {subscriptionTypes,agent,status, errors } = this.state;
     let {agent,errors } = this.state;
    //console.log("MY AGENT DATA 1111",agent);
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle} size={"lg"}>
          <ModalHeader
            className="bg-info text-light"
            toggle={this.props.toggle}
          >
            Create Agent Invoice
          </ModalHeader>
          <ModalBody>
            <Form className="row">
              
              <FormGroup className="col-6 ">
                <Label for="businessName">businessName</Label>
                <Input
                  type="text"
                  name="businessName"
                  id="businessName"
                  placeholder="businessName"
                  value={agent["businessName"]}
                
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="proprietorName">proprietorName</Label>
                <Input
                  type="text"
                  name="proprietorName"
                  id="proprietorName"
                  placeholder="proprietorName"
                  value={agent["proprietorName"]}
                 
                 disabled
                />
              </FormGroup>
              
              <FormGroup className="col-6">
                <Label for="cityId">city Name</Label>
                <Input
                  type="text"
                  name="cityName"
                  id="cityName"
                  value={agent["cityName"]}
                  placeholder="cityName"
                  
                  
                   disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="subscription Balance">subscription Balance</Label>
                <Input
                  type="text"
                  name="subscriptionBalance"
                  id="subscriptionBalance"
                  value={agent["subscriptionBalance"]}
                  placeholder="subscriptionBalance"
                  
                 disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="subscriptionExpiry">subscription Expiry</Label>
                <Input
                  type="text"
                  name="subscriptionExpiry"
                  id="subscriptionExpiry"
                  value={
                    moment(agent["subscriptionExpiry"]).format('DD-MM-YYYY')
                  }
                  placeholder="subscriptionExpiry"
                
                   disabled
                />
              </FormGroup>
              <FormGroup className="col-6 formGroup">
                <Label for="adjustmentAmount">adjustment Amount</Label>
                <Input
                  type="text"
                  name="adjustmentAmount"
                  id="adjustmentAmount"
                  value={agent["adjustmentAmount"]}
                  placeholder=" Enter Adjustment Amount"
                  invalid={Boolean(errors["adjustmentAmount"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup className="col-6 formGroup">
                <Label for="itemName">Item Name</Label>
                <Input
                  type="text"
                  name="itemName"
                  id="itemName"
                  value={agent["itemName"]}           
                  placeholder=" Enter Item Name"
                  invalid={Boolean(errors["itemName"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup className="col-6 formGroup">
                <Label for="amountDue">Amount Due</Label>
                <Input
                  type="text"
                  name="amountDue"
                  id="amountDue"            
                  value={agent["amountDue"]}
                  placeholder=" Enter amount Due"
                  invalid={Boolean(errors["amountDue"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup className="col-6 formGroup">
                <Label for="discount">Discount</Label>
                <Input
                  type="text"
                  name="discount"
                  id="discount"              
                  value={agent["discount"]}
                  placeholder=" Enter Discount"
                  invalid={Boolean(errors["discount"])}
                  onChange={this.handleChange}
                />
              </FormGroup>
              <FormGroup className="col-6">
        <Label for="dueDate">
        Due Date
        </Label>
        <br/>
        <DatePicker
         // style={{ dipslay: "block" }}
          dateFormat="dd/MM/yyyy"
          placeholderText= "Enter date"
          value={
            moment(agent["dueDate"]).format('DD-MM-YYYY')
          }
          //selected={agent.dueDate}
          invalid={Boolean(errors["dueDate"])}
          onChange={this.handledDueDate}
        />
        
        </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.handleSubmit}>
             Create Invoice
            </Button>{" "}
            <Button color="danger" onClick={this.props.toggle}>
            منسوخ کریں
            </Button>
          </ModalFooter>
        </Modal>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default CreateAgentInvoiceForm;